<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Update Cast & Crew Details</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cast_name"
                type="text"
                name="cast_name"
                id="cast_name"
              />
              <label>Cast Name</label>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="alt_cast_name"
                type="text"
                name="alt_cast_name"
                id="alt_cast_name"
              />
              <label>Name (Arabic)</label>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex justify-content-between align-item-center">
            <label
              class="material-file-upload"
              @click.prevent.stop="setModalData(null, null)"
            >
              <div
                class="label"
                v-bind:class="{
                  'shift-up': cast_image_url,
                }"
              >
                {{ "Item Image" }}
              </div>
              <div class="uploaded-file-name">
                <div class="text-truncate pt-2 image_url_text">
                  {{ cast_image_url }}
                </div>
              </div>
            </label>

            <img
              width="40"
              height="40"
              class="rounded ml-2"
              @click="showFnbImage()"
              :src="_GetImagePath(cast_image_url)"
              v-if="cast_image_url.length > 0"
              v-b-tooltip.hover.top="
                'Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
              "
            />
            <img
              v-else
              width="35"
              height="35"
              class="rounded ml-2"
              alt="Empty Image"
              src="@/assets/img/icons/empty-image.svg"
              v-b-tooltip.hover.top="
                'Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
              "
            />
          </div>
          <p class="error_message">
            <!-- <span v-if="submitted && cast_image_url.length == 0"
              >Please Select Food Image File.</span
            > -->
          </p>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="cast_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="/master/cast-crew">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      id="selected-image-preview-modal"
      title="Cast & Crew"
    >
      <img :src="_GetImagePath(cast_image_url)" class="img-fluid" />
    </b-modal>

    <ImageGallery
      v-bind:propImageName="cast_name"
      :img_desc="cast_name"
      :showPercentageLoader="true"
      v-bind:openModal="showModal"
      v-bind:set_height="null"
      v-bind:set_width="null"
      v-bind:menu="'C'"
      v-bind:category="`Actor`"
      :resetImgData="false"
    ></ImageGallery>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { mapGetters } from "vuex";
import ImageGallery from "../../ImageGallery/imageGalleryModal";

export default {
  components: { VueCropper, ImageGallery },
  data() {
    return {
      btenable: false,
      cast_name: "",
      mcm_id: null,
      alt_cast_name: "",
      cast_image_url: "",
      cast_is_active: "Y",
      set_height: null,
      set_width: null,
      submitted: false,
      showModal: false,
    };
  },
  computed: {
    ...mapGetters(["finalImagePath"]),
  },
  watch: {
    finalImagePath(newval) {
      this.cast_image_url = newval;
    },
  },
  mounted() {},
  beforeMount() {
    const { mcm_id } = this.$route.query;

    if(!this.$can('update', 'Crews')) {
      this.$router.go(-1);
    }

    if (mcm_id) {
      this.mcm_id = mcm_id;
      this.getItemsDetails(mcm_id);
    }
  },
  methods: {
    showFnbImage: function () {
      this.$refs["preview-modal"].show();
    },
    setModalData(height, width) {
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
    getItemsDetails(mcm_id) {
      let loader = this.$loading.show();
      let payload = {
        mcm_id: mcm_id,
      };
      MasterService.GetSingleCastNCrewDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            const {
              cast_name,
              mcm_id,
              alt_cast_name,
              cast_image_url,
              cast_is_active,
            } = data.Records[0];
            this.cast_name = cast_name;
            this.alt_cast_name = alt_cast_name;
            this.cast_image_url = cast_image_url;
            this.mcm_id = mcm_id;
            this.cast_is_active = cast_is_active;
          } else {
            this.$toasted.show(data.message || "Unable to fetch data");
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.cast_name) {
        return this.$toasted.show("Please Enter Cast Name");
      } else {
        let loader = this.$loading.show();
        let payload = {
          mcm_id: this.mcm_id,
          cast_name: this.cast_name,
          alt_cast_name: this.alt_cast_name,
          cast_image_url: this.cast_image_url,
          cast_is_active: this.cast_is_active || "Y",
        };
        MasterService.UpdateCastNCrewDetails(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "/master/cast-crew",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    resetForm: function () {
      this.mcm_id = null;
      this.cast_name = "";
      this.alt_cast_name = "";
      this.cast_image_url = "";
      this.cast_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CastNCrewComponents/UpdateCastNCrewMaster.vue